exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-0a97f130] {\n  font-size: 65px;\n  padding-right: 20px;\n}\n.el-select-dropdown__item[data-v-0a97f130] {\n  font-size: 14px;\n  padding: 8px 10px;\n  position: relative;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #48576a;\n  height: 100px !important;\n  line-height: 1.5;\n  box-sizing: border-box;\n  cursor: pointer;\n  align-items: center !important;\n}\n.icontainer[data-v-0a97f130] {\n  display: flex;\n  align-items: center;\n}", ""]);

// exports
